import React from 'react';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { DefaultButton, Modal, PrimaryButton } from '@fluentui/react';

function ConfirmModal({ isConfirmOpen, closeConfirmModal, handleSubmit, children }) {
    return (
        <Modal isOpen={isConfirmOpen} onDismiss={closeConfirmModal}>
            <div css={css`padding: 30px;`}>
                {children}
                <PrimaryButton
                    text="Yes, Submit"
                    onClick={handleSubmit}
                    style={{ marginRight: '20px', marginTop: '20px' }}
                />
                <DefaultButton text="No, Cancel" onClick={closeConfirmModal} />
            </div>
        </Modal>
    );
}

export default ConfirmModal;
